import React from 'react';

import DayjsUtils from '@date-io/dayjs';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Dayjs } from 'dayjs';
import jaLocale from 'dayjs/locale/ja';

class JaDayjsUtils extends DayjsUtils {
  getCalendarHeaderText(date: Dayjs): string {
    return this.format(date, `YYYY年 MMMM`);
  }
}

export const PickerUtilsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <MuiPickersUtilsProvider utils={JaDayjsUtils} locale={jaLocale}>
      {children}
    </MuiPickersUtilsProvider>
  );
};
